<template>
  <div class="container">
    <div class="row">
      <a
        @click="goBack"
        class="hover-pointer"
        style="position: absolute; top: 10px; left: 10px; font-size: 15px; font-weight:700; color:#06a6e0"
      >
        <i class="material-icons">arrow_back</i>
        <span style="">Go Back</span>
      </a>
      <div
        class="col-sm-4 offset-sm-4"
        style="margin: 145px auto;border: 2px solid #07a7e14f;"
      >
        <div class="form-group" style="text-align: center;margin-top: -105px;">
          <img
            :src="basepath+'/unodc_logo.png'"
            alt
            width="160"
            @click="goBack"
            class="hover-pointer"
          />
          <h4 class="text-center text-secondary">Reset password</h4>
        </div>
        <div style="text-align:left !important;">
          <form @submit.prevent="resetPassword">
            <div class="form-group">
              <div class="floating-label">
                <input
                  class="floating-input form-control"
                  v-model="oldPassword"
                  type="password"
                  placeholder
                />

                <span
                  class="lbl-label"
                  style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                >
                  <i class="material-icons" style="font-size: 20px;">vpn_key</i>
                </span>
                <label class="lbl-label">Old Password</label>
              </div>
              <div class="floating-label">
                <input
                  class="floating-input form-control"
                  v-model="password"
                  type="password"
                  placeholder
                />

                <span
                  class="lbl-label"
                  style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                >
                  <i class="material-icons" style="font-size: 20px;">vpn_key</i>
                </span>
                <label class="lbl-label">New Password</label>
              </div>
              <div class="floating-label">
                <input
                  class="floating-input form-control"
                  v-model="c_password"
                  type="password"
                  placeholder
                />

                <span
                  class="lbl-label"
                  style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                >
                  <i class="material-icons" style="font-size: 20px;">vpn_key</i>
                </span>
                <label class="lbl-label">Confirm Password</label>
              </div>
            </div>

            <div class="form-group" style="text-align: center;">
              <button
                type="submit"
                style="background-color: #07a7e1c2;border:1px solid #07a7e1c2;width: 100%"
                class="btn btn-primary"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    oldPassword:"",
    password: "",
    c_password: "",
    basepath: localStorage.getItem("BASE_PATH"),
  }),
  mounted() {
    this.token = this.$route.params.token;
    axios
      .get(localStorage.getItem("BASE_PATH") + "/resetPassword/" + this.token
        )
        .then(response => {
        if (response.data.success) {
          this.$toasted.global.successMsg(response.data.success);
        }
        if (response.data.error) {
          this.$toasted.global.errorMsg(response.data.error);
          setTimeout(() => {
            this.$router.push("/");
          }, 1000);
        }
      });
  },
  components: {},
  methods: {
    resetPassword(e) {
      // return false;
      e.preventDefault();
      this.inValid = [];
       if (!this.oldPassword) {
        this.inValid.push("Please enter your old password.");
      }
      if (!this.password) {
        this.inValid.push("Please enter your new password.");
      }
      if (!this.c_password) {
        this.inValid.push("please fill this field too");
      }
      if (this.password != this.c_password) {
        this.inValid.push("password not matched");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        let self = this;
        this.openLoading();
       let currentUser = JSON.parse(localStorage.getItem("currentUser"));

        axios
          .post(
            localStorage.getItem("BASE_PATH") + "/admin/user/update-password",
            {
              oldPassword: this.oldPassword,
              newPassword: this.password,
              id: currentUser.id,
            }
          )
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess(response.data.success);
              setTimeout(() => {
                this.$router.push("/");
              }, 1000);

            } else if (response.data.error) {
              self.toastError(response.data.error);
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 10000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 10000,
        variant: "danger",
        solid: true
      });
    },
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
     goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>

.floating-label {
  position: relative;
  margin-bottom: 5px;
}
.floating-input,
.floating-select {
  font-size: 14px;
  padding: 4px 30px 4px 5px;
  display: block;
  width: 100%;
  height: 36px;
  box-shadow: none !important;
  border: none;
  border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
  outline: none;
  border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
  color: #ccc;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 6px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.floating-input:focus ~ label.lbl-label,
.floating-input:not(:placeholder-shown) ~ label.lbl-label {
  background-color: #fff;
  top: -12px;
  left: 10px;
  font-size: 14px;
  color: rgba(7, 167, 225, 0.61);
  padding: 0px 5px;
}

.floating-select:focus ~ llabel.lbl-label,
.floating-select:not([value=""]):valid ~ label.lbl-label {
  top: -18px;
  font-size: 14px;
  color: #5264ae;
}

/* active state */
.floating-input:focus ~ .bar:before,
.floating-input:focus ~ .bar:after,
.floating-select:focus ~ .bar:before,
.floating-select:focus ~ .bar:after {
  width: 50%;
}

*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

/* highlighter */
.highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
}

/* active state */
.floating-input:focus ~ .highlight,
.floating-select:focus ~ .highlight {
  -webkit-animation: inputHighlighter 0.3s ease;
  -moz-animation: inputHighlighter 0.3s ease;
  animation: inputHighlighter 0.3s ease;
}
.hover-pointer:hover {
  cursor: pointer;
}
/* animation */
@-webkit-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@-moz-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}

@media (max-width: 768px) {
  .login-button {
    width: 100% !important;
  }
}
</style>
